import classnames from 'classnames'
import { Icon } from '@atoms'
import { getNextSorting } from './getNextSorting'
import { SortingOrder } from './SortingIconButton'

type SortingIconProps = {
    order: SortingOrder
}

export const SortingIcon: React.FC<SortingIconProps> = (props) => {
    const { order } = props
    const { topArrowClassname, bottomArrowClassname } =
        getArrowsClassnames(order)

    return (
        <div className="relative">
            <Icon
                size="small"
                className="block opacity-0"
                name={'unfold_more'}
            />
            <div className={topArrowClassname}>
                <Icon size="small" className="block" name={'unfold_more'} />
            </div>
            <div className={bottomArrowClassname}>
                <Icon size="small" className="block" name={'unfold_more'} />
            </div>
        </div>
    )
}

const getArrowsClassnames = (order: SortingOrder) => {
    const nextOrder = getNextSorting(order)

    const arrowBaseClassname = classnames('absolute inset-0 h-full w-full')

    const topArrowClassname = classnames(
        arrowBaseClassname,
        '[clip-path:polygon(0%_0%,100%_0%,100%_50%,0%_50%)]',
        {
            'text-neutral-800': order === 'asc',
            'text-neutral-500': ['desc', undefined].includes(order),
            'group-hover/icon:text-azure': ['asc', undefined].includes(
                nextOrder
            ),
        }
    )

    const bottomArrowClassname = classnames(
        arrowBaseClassname,
        '[clip-path:polygon(0%_50%,100%_50%,100%_100%,0%_100%)]',
        {
            'text-neutral-800': order === 'desc',
            'text-neutral-500': ['asc', undefined].includes(order),
            'group-hover/icon:text-azure': ['desc', undefined].includes(
                nextOrder
            ),
        }
    )

    return { topArrowClassname, bottomArrowClassname }
}
